import { IStoryList } from '@coreStory/type';
import { WhatIfStoryViewResponse } from '../whatif/types';

export const getStoryDetailsTransformer = (
  storyList: IStoryList[],
): IStoryList[] => {
  const story: any = [];
  storyList.map((storyDetail) => {
    const { StoryImage, ...rest } = storyDetail;
    story.push(
      {
        StoryImage: StoryImage,
      },
      {
        ...rest,
        VOrder: (Number(storyDetail?.VOrder) || 0) + 1,
      },
    );
  });
  return story;
};

export const getMobileStoryDetailsTransformer = (
  storyList: IStoryList[],
): IStoryList[] => {
  return storyList.map((storyDetail) => {
    return {
      ...storyDetail,
      VOrder: (Number(storyDetail?.VOrder) || 0) + 1,
    };
  });
};

export const getMobileWhatIfStoryDetailsTransformer = (
  storyList: WhatIfStoryViewResponse[],
): WhatIfStoryViewResponse[] => {
  return storyList.map((storyDetail) => {
    const order = Number(storyDetail?.VOrder) || 0;
    return {
      ...storyDetail,
      VOrder: 1 + order,
    };
  });
};

export const getWhatIfStoryDetailsTransformer = (
  storyList: WhatIfStoryViewResponse[],
): WhatIfStoryViewResponse[] => {
  const story: any = [];
  storyList.map((storyDetail) => {
    const { StoryImage, ...rest } = storyDetail;
    story.push(
      {
        StoryImage: StoryImage,
      },
      {
        ...rest,
        StoryImage: StoryImage,
        VOrder: (Number(storyDetail?.contentVOrder) ?? 0) + 1,
      },
    );
  });
  return story;
};
